export interface DemoDT {
    phone: string;
    email?: string;
    first_name: string;
    middle_name?: string;
    last_name: string;
    user: string;
    photo?: FileList;
    status: "synced" | "unsynced" | "partial-sync";
    creation?: string;
    modified?: string;
}

export const DEMO_SCHEMA = "phone, email, first_name, middle_name, last_name, user, photo, status, creation, modified";
